<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12" md="3" >

                <v-select class="v-select" item-text='code' v-model="selected" return-object :items="countries" outlined :label="$t('country')">

                    <template class="d-flex" v-slot:selection="{ item }">
                        <v-list class="selection selection2 d-flex" dense>

                            <v-list-item class="selection selection2 list-item-1 flag">
                                <v-list-item-icon>
                                    <img class="img-br" v-if="item.code === 'BR'" src="../../../assets/br-flag.png" />
                                    <img class="img-pr" v-else-if="item.code === 'PE'" src="../../../assets/pr-flag.png" />
                                    <v-icon class="icon-flag" v-else>mdi-flag-outline</v-icon>
                                </v-list-item-icon>
                            </v-list-item>

                        </v-list>

                    </template>

                    <template class="d-flex" v-slot:item="{ item }">
                        <v-list class="selection selection2 d-flex " dense>

                            <v-list-item class="selection selection2 list-item-2">
                                <v-list-item-icon>
                                    <img class="img-br2" v-if="item.code === 'BR'" src="../../../assets/br-flag.png" />
                                    <img class="img-pr" v-else-if="item.code === 'PE'" src="../../../assets/pr-flag.png" />
                                    <v-icon class="icon-flag2" v-else>mdi-flag-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content class="item-content">
                                    <v-list-item-title :class="('item-title' + Math.random())" v-text="item.code"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                        </v-list>

                    </template>
                </v-select>
            </v-col>

            <v-col cols="12" md="9" >
                <v-text-field class="phone-field" :prefix="selected.prefixPhone" @change="onInput" outlined v-mask="mask" v-model.trim="phone" :label="label" :placeholder="$t('fields.phone.placeholder')" :rules="phoneRules" :disabled="loading" type="tel" :append-icon="icon === 'whatsapp' ? 'mdi-whatsapp' : 'mdi-phone'" required />
            </v-col>

        </v-row>

    </div>
</template>

<script>

import { mask } from 'vue-the-mask';
import validators from '../../../utils/validators';

export default {
    name: 'CountryNumber',

    directives: { mask },

    props: ['idInput', 'phoneNumber', 'label', 'rules', 'icon'],

    data() {
        return {
            countries: [
                {

                    prefixPhone: '55',
                    code: 'BR',
                    name: 'Brazil',
                    icon: "../../assets/br-flag.png"

                },
                {

                    prefixPhone: '51',
                    code: 'PE',
                    name: 'Peru',
                    icon: "../../assets/pr-flag.png"

                },
                {

                    prefixPhone: '',
                    code: this.$t('other_country'),
                    name: this.$t('other_country'),
                    icon: "../../assets/pr-flag.png"

                }

            ],
            phone: '',
            mask: '(##) #####-#######',
            selected: {
                    prefixPhone: '55',
                    code: 'BR',
                    name: 'Brazil',
                    icon: "../../assets/br-flag.png"
                },
            loading: false,
            phoneRules: [
                            v => validators.phone.only_numbers(v) || this.$t('validators.phone.only_numbers'),
                    ],   
            
        }
    },

    methods: {
        onInput(digit) {

            this.$emit('input' + this.idInput, this.selected.prefixPhone + digit)

        },

        setPhoneNumber(){

            this.phone = this.phoneNumber

        },

        setRules(){

            if (!this.rules) return true

            this.rules.forEach(rule => {
                
                if (rule === 'required') this.phoneRules.push(v => validators.phone.required(v) || this.$t('validators.phone.required'))
                if (rule === 'min') this.phoneRules.push(v => validators.phone.min_length(v) || this.$t('validators.phone.min_length'))


            });

        },


    },

    watch: {
        selected: function(obj) {

            if (obj.code !== 'BR') return this.mask = '##############'

            return this.mask = '(##) #####-#######'


        }
    },

    created() {

        this.setPhoneNumber()
        this.setRules()
        
    },

}
</script>

<style scoped>

.img {

    height: 50px;
    width: 50px;


}

.selection {

    padding: 0px;
    margin: 0px;


}

.selection2 {

    width: 100%;
    background-color: transparent;


}

.row {

    width: 100%;
    height: 100%;

}


</style>